import { fetchWrapper, RequestMethod } from 'helpers';

export const getReturnUrlParams = (paymentId: string) => async (): Promise<Record<string, string | number>> =>
	fetchWrapper<Record<string, string | number>>(`/payments/${paymentId}/return-url`, { method: RequestMethod.GET });
